import tw from "twin.macro";
import React from "react";

export type SettingRowProps = {
  icon: React.ReactNode;
  label: string;
  description: string;
  trailing: React.ReactNode;
  muted?: boolean;
};

function SettingRow({
  icon,
  label,
  description,
  trailing,
  muted,
}: SettingRowProps) {
  return (
    <div css={[tw`flex items-center gap-1 py-3 px-1`, muted && tw`opacity-60`]}>
      <div
        css={tw`w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-white`}
      >
        {icon}
      </div>
      <div css={tw`flex flex-col flex-1 min-w-0`}>
        <span css={tw`text-sm font-semibold text-gray-800`}>{label}</span>
        <span css={tw`text-xs text-gray-500 mt-0.5`}>{description}</span>
      </div>
      {trailing}
    </div>
  );
}

export default SettingRow;
